import useMinimalShopForPageType from './use-minimal-shop-for-page-type';

enum ShopIdWithDifferentBoatType {
  KentuckyCruises = '65b265e95e8a97b2f9b6110a',
  GoBoatCruise = '65af8164f6bc14659d1b7cdc',
  GoBoatCruiseLite = '666943e64077de28b77ab350',
}

// Set the max number of persons per unit for shops with other boat types
const maxPersonsByShopId: Record<ShopIdWithDifferentBoatType, number> = {
  // gb cruise has max 8 for now
  [ShopIdWithDifferentBoatType.KentuckyCruises]: 7,
  [ShopIdWithDifferentBoatType.GoBoatCruise]: 9,
  [ShopIdWithDifferentBoatType.GoBoatCruiseLite]: 7,
};

function isShopIdWithDifferentBoatType(
  shopId: string
): shopId is ShopIdWithDifferentBoatType {
  return shopId in maxPersonsByShopId;
}

const usePersonsPerUnit = () => {
  const shop = useMinimalShopForPageType();

  const shopId = String(shop?.id);

  return isShopIdWithDifferentBoatType(shopId) ? maxPersonsByShopId[shopId] : 8;
};

export default usePersonsPerUnit;
